import { render, staticRenderFns } from "./rotatable-img.vue?vue&type=template&id=a41bc8a4&scoped=true"
import script from "./rotatable-img.vue?vue&type=script&lang=js"
export * from "./rotatable-img.vue?vue&type=script&lang=js"
import style0 from "./rotatable-img.vue?vue&type=style&index=0&id=a41bc8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41bc8a4",
  null
  
)

export default component.exports